/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { motion } from 'framer-motion';
import Link from 'next/link';

export const MainNavigator = ({
  item,
  i,
  setDesktopMenuOpen,
  setActiveSidebarSubNav,
  isActive,
  linkVariants,
  hasSub,
}: {
  item: any;
  i: number;
  setDesktopMenuOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setActiveSidebarSubNav: React.Dispatch<React.SetStateAction<any>>;
  isActive?: boolean;
  linkVariants: any;
  hasSub?: boolean;
}) => {
  return (
    <motion.div key={item.name} custom={i} initial='hidden' animate='visible' exit='exit' variants={linkVariants} className='relative'>
      {hasSub ? (
        <button onClick={() => setActiveSidebarSubNav(item)} className={`group flex w-full justify-between items-center px-3 py-2 rounded-md text-2xl text-dark-100 ${isActive ? 'active font-bold' : 'font-medium'}`}>
          <p>{item.name}</p>
          <div className={`size-2 bg-dark-100 rounded-full transition-opacity duration-300 ease-in-out ${isActive ? 'opacity-100' : 'opacity-0 group-hover:opacity-100'}`} />
        </button>
      ) : (
        <Link href={item.href} onClick={() => setDesktopMenuOpen(false)} className={`group flex w-full justify-between items-center px-3 py-2 rounded-md text-2xl text-dark-100 ${isActive ? 'active font-bold' : 'font-medium'}`}>
          <p>{item.name}</p>
          <div className={`size-2 bg-dark-100 rounded-full transition-opacity duration-300 ease-in-out ${isActive ? 'opacity-100' : 'opacity-0 group-hover:opacity-100'}`} />
        </Link>
      )}
    </motion.div>
  );
};
